import React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import CounterRate from "../../metrics/CounterRate";
import useForwarderInputState from "../../hooks/useForwarderInputState";
const TrafficLastMinuteCell = ({ forwarderId, inputId }) => {
  var _a;
  const { t } = useTranslation("enterprise_forwarder");
  const { data, isPending } = useForwarderInputState(forwarderId != null ? forwarderId : "", inputId);
  const incomingMessagesMetric = (_a = data == null ? void 0 : data.metrics) == null ? void 0 : _a.find((m) => m.name === "incomingMessages");
  if (!forwarderId) {
    return /* @__PURE__ */ React.createElement("em", null, t("common.not_available"));
  }
  if (isPending) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  if (!incomingMessagesMetric) {
    return /* @__PURE__ */ React.createElement("span", null, t("traffic_last_minute_cell.not_available"));
  }
  return /* @__PURE__ */ React.createElement(CounterRate, { metric: incomingMessagesMetric, suffix: "msg/s" });
};
export default TrafficLastMinuteCell;
